import { HTTP_CONTEXT_FIELDS } from './constants';
import getHttpContextValue from './getHttpContextValue';

const isBotRequest = () =>
  getHttpContextValue(HTTP_CONTEXT_FIELDS.IS_BOT_REQ, false);

export default isBotRequest;
